export enum DrawerIds {
  AlarmProfileEditRecipientsDrawer = "alarmProfileEditRecipientsDrawerModal",
  AlarmProfilesDrawer = "alarmProfilesDrawerModal",
  DevDrawer = "devDrawerModal",
  TileDrawer = "tileDrawerModal",
}
